module.exports = __webpack_public_path__ + "static/media/sec-3-img-5.79ad1637.png";